module.exports = __webpack_public_path__ + "img/icon_guide@3x.3ce3e9c5.png";